// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"InfoSection_infoSection__1ijUD","infoSectionHeading":"InfoSection_infoSectionHeading__bMjpu","infoSectionSubheading":"InfoSection_infoSectionSubheading__r0HKj"};